module.exports = __webpack_public_path__ + "static/scale-model-of-escondido-history-center-in-escondido-california-2a7845e655964338ac55de05eed0d72f.png";